module.exports = __webpack_public_path__ + "assets/img/ring_blue.6960e90a.png";